// Pulls overall configuration from external data.js file found in public dir.
// Different versions available
export const OPTIONS = window.OPTIONS;
//export const CONFIG = window.CONFIG; // TODO: Want to shift this to a dynamic fix
